import { isEligibleCityListing } from '@/utils/cityArea';

// Keep the existing tab key for compatibility; it now represents Autoutilitare.
export const BUYER_CATEGORY_CODES = { used: ['cars', 'suv'], truck: ['van'], motorcycle: ['motorcycle', 'atv'] } as const;
export const BUYER_SEARCH_TYPES = { used: 'car', truck: 'van', motorcycle: 'motorcycle' } as const;

export function hasPositiveBuyerCount(count: number | null | undefined): count is number {
  return typeof count === 'number' && Number.isFinite(count) && count > 0;
}

export function countBuyerCategories(rows: Array<{ status?: string | null; category_code?: string | null }>) {
  const active = rows.filter(row => row.status == null || row.status === 'active');
  return {
    used: active.filter(isEligibleCityListing).length,
    truck: active.filter(row => row.category_code === BUYER_CATEGORY_CODES.truck[0]).length,
    motorcycle: active.filter(row => BUYER_CATEGORY_CODES.motorcycle.some(code => code === row.category_code)).length,
  };
}